var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-table"},[_c('div',{staticClass:"form"},[_vm._t("form")],2),_vm._t("table")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }